// Imported before App in index.tsx so it runs ahead of the store's creation.
import { handleWebmailLogoutRedirect } from "utils/direct-mailbox-login";

handleWebmailLogoutRedirect();
